import React from "react";

interface Props {
  children: React.ReactNode;
  resetKey?: string;
}

export default class ErrorBoundary extends React.Component<
  Props,
  { error: Error | null }
> {
  state = { error: null as Error | null };

  static getDerivedStateFromError(error: unknown) {
    return { error: error instanceof Error ? error : new Error(String(error)) };
  }
  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error(
      "Erreur de rendu de l’application",
      error,
      info.componentStack,
    );
  }
  componentDidUpdate(previous: Props) {
    if (previous.resetKey !== this.props.resetKey && this.state.error) {
      this.setState({ error: null });
    }
  }
  render() {
    if (!this.state.error) return this.props.children;
    const failedImport =
      /ChunkLoadError|Loading chunk|dynamically imported module|Failed to fetch dynamically|Importing a module script/i.test(
        `${this.state.error.name} ${this.state.error.message}`,
      );
    return (
      <div role="alert" className="p-4">
        <p>Ce contenu n’a pas pu être affiché.</p>
        {failedImport && (
          <p>
            Le chargement a échoué. Rechargez l’application pour récupérer la
            version disponible.
          </p>
        )}
        <button
          type="button"
          className="btn btn-primary"
          onClick={() =>
            failedImport
              ? window.location.reload()
              : this.setState({ error: null })
          }
        >
          {failedImport ? "Recharger l’application" : "Réessayer"}
        </button>
        {!failedImport && (
          <button
            type="button"
            className="btn btn-secondary ms-2"
            onClick={() => window.location.reload()}
          >
            Recharger l’application
          </button>
        )}
      </div>
    );
  }
}
